/**
 * Inline trend sparklines for the Marketing report's tables.
 */

// Inline sparkline for CPMr ad fatigue tracking
export function CpmrSparkline({ data, width = 64, height = 20 }) {
  if (!data || data.length < 2) return null
  const min = Math.min(...data)
  const max = Math.max(...data)
  const range = max - min || 1

  const points = data.map((v, i) => {
    const x = (i / (data.length - 1)) * width
    const y = height - 2 - ((v - min) / range) * (height - 4)
    return `${x},${y}`
  }).join(' ')

  // Red if trending up (fatigue), green if trending down, amber if flat
  const pctChange = data[0] > 0 ? ((data[data.length - 1] - data[0]) / data[0]) * 100 : 0
  const color = pctChange > 10 ? '#EF4444' : pctChange < -10 ? '#22C55E' : '#F59E0B'

  return (
    <svg width={width} height={height} className="inline-block align-middle">
      <polyline points={points} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

// Inline sparkline for traffic quality. Deliberately the mirror of
// CpmrSparkline: there, rising cost is bad; here, rising quality is GOOD, so
// the colour scale is inverted. Gaps (periods with too little traffic to score)
// are nulls and are skipped rather than drawn as a dive to zero.
export function QualitySparkline({ data, width = 64, height = 20 }) {
  if (!data) return null
  const points = data
    .map((v, i) => ({ v, i }))
    .filter(p => p.v !== null && p.v !== undefined && Number.isFinite(p.v))
  if (points.length < 2) return null

  const values = points.map(p => p.v)
  const min = Math.min(...values)
  const max = Math.max(...values)
  const range = max - min || 1
  const lastIndex = data.length - 1 || 1

  const coords = points.map(p => {
    const x = (p.i / lastIndex) * width
    const y = height - 2 - ((p.v - min) / range) * (height - 4)
    return `${x},${y}`
  }).join(' ')

  const first = values[0]
  const last = values[values.length - 1]
  const pctChange = first > 0 ? ((last - first) / first) * 100 : 0
  // Inverted vs CPMr: up = improving quality = green.
  const color = pctChange > 10 ? '#22C55E' : pctChange < -10 ? '#EF4444' : '#F59E0B'

  return (
    <svg
      width={width}
      height={height}
      className="inline-block align-middle"
      role="img"
      aria-label={`Quality trend ${pctChange >= 0 ? 'up' : 'down'} ${Math.abs(pctChange).toFixed(0)}%`}
    >
      <polyline points={coords} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
